export const API_URl = 'https://forkify-api.jonas.io/api/v2/recipes/';

export const TIMOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const KEY = '071ae914-de82-40eb-965e-69932851665f';

export const MODAL_CLOSE_SEC = 2;